var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bars",
    className: "st0",
    d: "M5.4,17.6h61.3c1.3,0,2.4-1.1,2.4-2.4V9.4C69,8.1,67.9,7,66.6,7H5.4C4.1,7,3,8.1,3,9.4 v5.9C3,16.6,4.1,17.6,5.4,17.6z M5.4,41.2h61.3c1.3,0,2.4-1.1,2.4-2.4v-5.9c0-1.3-1.1-2.4-2.4-2.4H5.4c-1.3,0-2.4,1.1-2.4,2.4 c0,0,0,0,0,0v5.9C3,40.1,4.1,41.2,5.4,41.2C5.4,41.2,5.4,41.2,5.4,41.2L5.4,41.2z M5.4,64.7h61.3c1.3,0,2.4-1.1,2.4-2.4v-5.9 c0-1.3-1.1-2.4-2.4-2.4H5.4c-1.3,0-2.4,1.1-2.4,2.4v5.9C3,63.7,4.1,64.8,5.4,64.7L5.4,64.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHam);
export default __webpack_public_path__ + "static/media/ham.386afc7555b5e310f4b3ad11d7d40db3.svg";
export { ForwardRef as ReactComponent };